import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ArticlePage from "@/pages/article/page";
import ArticlesListPage from "@/pages/articles/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/articles",
    element: <ArticlesListPage />,
  },
  {
    path: "/articles/:slug",
    element: <ArticlesListPage />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;